import React, { useState } from 'react';
import { Link } from 'gatsby';

import { mergeSelectors, useWindowSize } from './helper';
import { ExpandButton } from './ExpandButton';
import { MenuItem } from '../types';

interface MenuLinkProps {
  closeMenu: () => void;
  data: MenuItem;
  depth?: number;
}

export const MenuLink = ({
  data: { label, path, className, newTab, submenu, openNested = false },
  closeMenu,
  depth = 0,
}: MenuLinkProps) => {
  const [showNested, setNested] = useState(openNested);
  const { width } = useWindowSize();

  return (
    <li
      className={mergeSelectors([
        'menu-item',
        submenu ? 'has-submenu' : undefined,
        showNested ? 'expanded' : undefined,
        className,
      ])}>
      <div className="flex">
        {newTab ? (
          <a
            href={path}
            target="_blank"
            rel="noopener noreferrer"
            onClick={width && width < 768 ? closeMenu : undefined}>
            {label}
          </a>
        ) : (
          <Link
            to={path as string}
            activeClassName="active"
            onClick={width && width < 768 ? closeMenu : undefined}>
            {label}
          </Link>
        )}
        {submenu ? <ExpandButton set={setNested} show={showNested} /> : null}
      </div>
      {submenu ? (
        <>
          {showNested ? (
            <ul
              className={mergeSelectors(['submenu', `depth-${depth}`])}
              role="menu"
              aria-label="submenu">
              {submenu.map((item, index) => (
                <MenuLink
                  key={index}
                  data={item}
                  depth={depth + 1}
                  closeMenu={closeMenu}
                />
              ))}
            </ul>
          ) : null}
        </>
      ) : null}
    </li>
  );
};
